<template>

  <div class="wrapper-admin d-flex flex-column">

    <div class="topbar bg-light p-3 d-flex">

      <div class="dropdown mr-3">
        <button class="btn btn-secondary dropdown-toggle" @click="dropDownBlocks = !dropDownBlocks">Blocos</button>
        <div class="dropdown-menu" :class="{'show':dropDownBlocks}">
          <button class="dropdown-item" v-for="block in components" @click="editBlock(block)">{{ block.category.name }} {{ block.name }}</button>
        </div>
      </div>
      <div class="mr-3">
        <button @click="newBlock" class="btn btn-primary">Novo</button>
      </div>

      <div class="btn-group btn-group-toggle" >
        <label class="btn btn-secondary" :class="{'active':previewDevice=='desktop'}"><input type="radio" v-model="previewDevice" value="desktop"> Desktop</label>
        <label class="btn btn-secondary" :class="{'active':previewDevice=='mobile'}"><input type="radio" v-model="previewDevice" value="mobile"> Mobile</label>
      </div>

    </div>

    <div class="row-preview d-flex">
      <main class="flex-fill">
        <div class="virtualPreview">
          <component :is="previewComponent"></component>
        </div>
        <div class="browser" :class="previewDevice">
          <div class="browser-header">
            <div class="top-bar">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="tab"></div>
            </div>
            <div class="field"></div>
          </div>
          <div class="browser-window">
            <iframe class="preview" src="/iframe-block-editor.html"></iframe>
          </div>
          <div class="browser-footer"></div>
        </div>
      </main>
      <aside class="aside-right">
        <component :is="asideComponent"></component>
      </aside>

    </div>

      <div class="row-edit d-flex">
        
        <div class="col-template d-flex">
          <div class="flex-grow-1" label="HTML"><textarea @change="update" v-model="editor.template"></textarea></div>
          <div class="flex-grow-1" label="CSS"><textarea @change="update" v-model="editor.css"></textarea></div>
          <div class="flex-grow-1" label="Javascript"><textarea @change="update" v-model="editor.js"></textarea></div>
        </div>
        <div class="col-data d-flex flex-column">
          <div class="flex-grow-1" label="model"><textarea @change="update" v-model="editor.data"></textarea></div>
          <div class="flex-grow-1" label="sidebar"><textarea @change="update" v-model="editor.aside"></textarea></div>
        </div>
      </div>

      <div class="footer col-id p-3 form-inline">

        <div class="form-group mr-5">
            <label class="mr-2">Name:</label>
            <input type="text" class="form-control" v-model="editor.name" @change="update">
        </div>
        <div class="form-group mr-5">
          <label class="mr-2">Image:</label>
          <div class="d-inline-flex mr-2">
          <!--
            <div class="custom-file">
            <input type="file" class="custom-file-input" @change="onFileChange($event,block,'image')">
            <label class="custom-file-label">Selecionar imagem</label>
          </div>
          -->
              <button class="btn btn-sm" @click.prevent="autoThumbnail">Generate</button>
          </div>
            
          <div v-if="block.image" class="d-inline-flex" style="max-height:38px; max-width:200px;">
            <img :src="block.image" class="img-thumbnail">
            <button class="close p-2" @click="block.image=''"><span>&times;</span></button>
          </div>

        </div>
        <div class="form-group mr-5">
          <label class="mr-2">Category</label>
          <select v-model="block.category_id" class="form-control">
            <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
            <option value="(+)">(New Category)</option>
          </select>
        </div>
        <div class="form-group">
          <button v-if="block.id" class="btn btn-primary" @click.prevent="saveBlock">Save</button>
          <button class="btn btn-primary" @click.prevent="saveNewBlock">Save as new</button>
          <button v-if="block.id" class="btn btn-danger" @click.prevent="deleteBlock">Delete</button>
        </div>
      </div>
  </div>

</template>
<style scoped>
  .topbar {  }
  .topbar-blocks {  }
  .topbar-preview-device {  }
  

  .wrapper-admin { flex-grow: 1; overflow: hidden; }

  .row-preview { flex:1; overflow: hidden;}
  .row-preview main{  flex-basis:70%; }
  .row-preview aside{ flex-basis:30%; overflow: auto; }

  .row-edit { flex:1;}
  /*
  .rows { height:100%; display: flex; flex-direction: column;}
  .row { flex: 1; overflow: auto; }
  .row-preview {  }
  .row-preview .flex { height: 100%; }

  .row-edit form { display: flex; height: 100%; }
  .row-edit label {display: block;}
  .row-edit p { margin:0; flex-grow: 1; position: relative;}
  .row-edit p:before {
    content:attr(label);
    opacity: .1;
    position: absolute;
    font-size:20px;
    top:50%;
    left: 50%;
    transform:translate(-50%,-50%);
   }


  .col { }

  */
  /* .row { margin:0; flex-wrap: nowrap;} */
  /* .col{ padding:0; } */
  /*
  */
  .col-template { flex-basis: 70%; font-size:.8em; }
  .col-data { flex-basis: 30%; flex-shrink: 0;  font-size:.8em; }
  .row-edit textarea { height: 100%; width: 100%; font:monospace; font-size:inherit; resize: none; }

.img-thumbnail { object-fit: contain;}

  .dropDownBlocks { position: relative; margin-right: 5px }
  .dropDownBlocks  ul { list-style:none; position: absolute; top:100%; left:0; background:#fff; padding:10px; box-shadow:1px 1px 5px rgba(0,0,0,.2); }
  .dropDownBlocks  ul li {cursor: pointer; padding:5px; }
  .dropDownBlocks  ul li:hover { background:#eee; }

  .button { background:#eee; display: inline-block; padding:2px 5px; cursor: pointer; border:1px outset #ccc; }




.browser {  transform-origin:top; display: flex; flex-direction: column; height: 100%; }
.browser.desktop { transform:scale(.8);  }
.browser.mobile { max-width:360px; margin-left:auto; margin-right:auto; }

.browser-header{ flex-shrink: 0;}
.browser .top-bar { height: 20px; background: #cccccc; border-radius: 3px 3px 0 0; text-align: left; display: block; }
.browser .top-bar .circle { display: inline-block; height: 8px; width: 8px; border-radius: 100%; background: #999999; }
.browser .top-bar .circle:first-child { margin-left: 7px; }
.browser .top-bar .tab { box-sizing: border-box; display: inline-block; border-radius: 6px 6px 0 0; height: 14px; width: 96px; margin-left: 8px; transform: translateY(6px); border-bottom: 14px solid #e6e6e6; border-left: 7px solid transparent; border-right: 7px solid transparent; }
.browser .field { height: 18px; background: #e6e6e6; }
.browser-window { flex-grow: 1; border-left:1px solid #ccc; border-right:1px solid #ccc;}
.preview { height:100%; width:100%; border:none; display: block; min-height: 300px;  }
.browser-footer{ border-bottom:1px solid #ccc;}

.virtualPreview { display: none; }

</style>

<script>

import componentFunctions from '../mixin.components.js'
import axios from 'axios';
import Vue from 'vue';
import domtoimage from 'dom-to-image';
import gHeader from '../components/gHeader.vue'


export default window.vmPage = {
  // props:['id','page_id'],
  mixins:[componentFunctions],
  components:{'g-header':gHeader},
  data() {
    return {
      dropDownBlocks:false,
      previewDevice:'desktop',
      asideComponent:null,
      previewComponent:null,
      block:{
        uid:'editor',
        id:null,
        name:'',
        image:'',
        category_id:null,
        data:{},
        aside:'',
        template:'',
        css:'',
        js:'',
      },
      editor:{
        name:'teste',
        data:`{
"address":"",
"email":"",
"password":"",
"checkbox1":false,
"checkbox2":[],
"radio":"",
"range":1,
"select":"",
"image":"",
"items":[]
          }`,
        aside:`
        <div>
<!-- text input with hint -->
<div class="form-group">
  <label>Address</label>
  <input v-model="address" type="text" class="form-control" placeholder="Address">
  <small class="form-text text-muted">Your password must be 8-20 characters long</small>
</div>


<!-- 2 columns -->
<div class="form-row">
  <div class="form-group col-md-6">
    <label>Email</label>
    <input v-model="email" type="email" class="form-control" placeholder="Email">
  </div>
  <div class="form-group col-md-6">
    <label>Password</label>
    <input v-model="password" type="password" class="form-control" placeholder="Password">
  </div>
</div>

<!-- checkbox -->
<div class="form-group">
  <div class="form-check">
    <label class="form-check-label">
      <input v-model="checkbox1" class="form-check-input" type="checkbox"> Check me out
    </label>
  </div>
</div>


<!-- checkbox inline -->
<div class="form-group">
  <label class="d-block">Checkbox inline</label>
  <div class="form-check form-check-inline">
    <label class="form-check-label">
      <input v-model="checkbox2" value="1" class="form-check-input" type="checkbox"> 
      1
    </label>
  </div>
  <div class="form-check form-check-inline">
    <label class="form-check-label">
      <input v-model="checkbox2" value="2" class="form-check-input" type="checkbox"> 
      2
    </label>
  </div>
  <div class="form-check form-check-inline">
    <label class="form-check-label">
      <input v-model="checkbox2" value="3" class="form-check-input" type="checkbox"> 
      3
    </label>
  </div>
</div>

<!-- radio -->
<div class="form-group">
  <label>Address</label>
  <div class="form-check">
    <label class="form-check-label">
      <input v-model="radio" value="1" class="form-check-input" type="radio" >
      Opcao 1
    </label>
  </div>
  <div class="form-check">
    <label class="form-check-label">
      <input v-model="radio" value="2" class="form-check-input" type="radio" >
      Opcao 2
    </label>
  </div>
  <div class="form-check">
    <label class="form-check-label">
      <input v-model="radio" value="3" class="form-check-input" type="radio" >
      Opcao 3
    </label>
  </div>
</div>


<!-- Range -->
<div class="form-group">
  <label>Number</label>
  <input v-model.number="range" min="0" max="5" type="range" class="custom-range">
  <small class="form-text text-muted">Between 0 and 5</small>
</div>



<!-- select -->
<div class="form-group">
  <label>Example select</label>
  <select v-model="select" class="form-control">
    <option>1</option>
    <option>2</option>
    <option>3</option>
    <option>4</option>
    <option>5</option>
  </select>
</div>


<!-- image upload -->
<div class="form-group">
  <label>Imagem</label>
  <div class="custom-file">
    <input type="file" class="custom-file-input" @change="onFileChange($event,_data,'image')">
    <label class="custom-file-label">Upload</label>
  </div>
  <div v-if="image" class="d-flex">
    <img :src="image" class="img-thumbnail">
    <button class="close p-2" @click="image=''"><span>&times;</span></button>
  </div>
</div>


<!-- image upload - tiny inline preview -->
<div class="form-group">
  <label>Imagem</label>
  <div class="d-flex">
    <div class="custom-file">
      <input type="file" class="custom-file-input" @change="onFileChange($event,_data,'image')">
      <label class="custom-file-label">Upload</label>
    </div>
    <div class="flex-shrink-0">
      <img v-if="image" :src="image" class="img-thumbnail" style="max-height:38px">
    </div>
    <button v-if="image" class="close p-2" @click="image=''"><span>&times;</span></button>
  </div>
</div>



<!-- repeat 1 field -->
<div class="form-group">
  <label class="d-block">Items</label>
  <div v-for="(item,index) in items" class="d-flex">
    <input type="text" v-model="item.title" class="form-control">
    <button class="close p-2" @click="removeRow(items,index)"><span>&times;</span></button>
  </div>
  <button class="btn btn-primary btn-sm" @click="addRow(items)">Adicionar</button>
</div>


<!-- repeat with image -->
<div class="form-group">
  <label class="d-block">Items</label>
  <div v-for="(item,index) in items" class="d-flex align-items-start mb-2">

    <div class="flex-fill">
      <input type="text" v-model="item.title" class="form-control">
      <div class="d-flex">
        <div class="custom-file">
          <input type="file" class="custom-file-input" @change="onFileChange($event,item,'image')">
          <label class="custom-file-label">Upload</label>
        </div>
        <div class="flex-shrink-0">
          <img v-if="item.image" :src="item.image" class="img-thumbnail" style="max-height:38px">
        </div>
      </div>
    </div>

    <button class="close p-2" @click="removeRow(items,index)"><span>&times;</span></button>

  </div>
  <button class="btn btn-primary btn-sm" @click="addRow(items,{image:''})">Adicionar</button>
</div>


<!-- repeat with table 3 fields -->
<div class="form-group">
  <label>Items</label>
  <div class="table-responsive">
    <table class="table table-borderless table-sm">
      <thead>
        <tr>
          <th>Text</th>
          <th>URL</th>
          <th>Class</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in items">
          <td><input type="text" v-model="item.title" class="form-control" placeholder="Text"></td>
          <td><input type="text" v-model="item.title" class="form-control" placeholder="URL"></td>
          <td>
            <select v-model="item.class" class="form-control">
              <option value="btn-primary">Primary</option>
              <option value="btn-secondary">Secondary</option>
              <option value="btn-success">Success</option>
              <option value="btn-danger">Danger</option>
              <option value="btn-warning">Warning</option>
              <option value="btn-info">Info</option>
              <option value="btn-light">Light</option>
              <option value="btn-dark">Dark</option>
              <option value="btn-link">Link</option>
            </select>
          </td>
          <td><button class="close p-2" @click="removeRow(items,index)"><span>&times;</span></button></td>
        </tr>
      </tbody>
    </table>
  </div>
  <button class="btn btn-primary btn-sm" @click="addRow(items)">Adicionar</button>
</div>

<!-- repeat with table 3 fields (2 rows) -->
<div class="form-group">
  <label>Items</label>
  <div class="table-responsive">
    <table class="table table-borderless table-sm">
      <thead>
        <tr>
          <th>Title<br>Class</th>
          <th>Text</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in items">
          <td>
            <input type="text" v-model="item.title" class="form-control" placeholder="Text">
            <select v-model="item.class" class="form-control">
              <option value="btn-primary">Primary</option>
              <option value="btn-secondary">Secondary</option>
              <option value="btn-success">Success</option>
              <option value="btn-danger">Danger</option>
              <option value="btn-warning">Warning</option>
              <option value="btn-info">Info</option>
              <option value="btn-light">Light</option>
              <option value="btn-dark">Dark</option>
              <option value="btn-link">Link</option>
            </select>
          </td>
          <td>
            <textarea v-model="item.text" class="form-control" placeholder="URL"></textarea>
          </td>
          <td><button class="close p-2" @click="removeRow(items,index)"><span>&times;</span></button></td>
        </tr>
      </tbody>
    </table>
  </div>
  <button class="btn btn-primary btn-sm" @click="addRow(items)">Adicionar</button>
</div>


        </div>`,
        template:`
        <div>
            {{ address }}
        </div>`,
        css:`
        p {
            color: var(--color);
        }

        .class1 p {
            margin-bottom: 10px
        }

        .class2 p {
            margin-bottom: 20px
        }`,
        js:'',
      },
      iframeDom:null,
      categories:[],
      components:[],
    }
  },
  
  watch:{
    'block.category_id':{
      handler:function(newVal,oldVal){
        if(newVal=='(+)'){
          this.block.category_id='';
          this.formNewCategory();
        }
      },
    }
  },
  
  methods:{

    formNewCategory(){
      var name = prompt('Nome da nova categoria');
      if(name){
        axios({
          method: 'post',
          url: '/api/block-categories',
          data: {name:name}
        }).then((res)=>{
          console.log(res);
          this.block.category_id = res.data.id;
          this.getComponents();
        }).catch((error)=>{
          alert('error');
          console.log(error);
        });

      }
    },

    getComponents(){

      axios({
        url: '/api/block-categories',
      }).then((res) => {
        this.categories = res.data
      });
      axios({
        url: '/api/blocks',
      }).then((res) => {
        this.components = res.data
      });
    },

    editBlock(block){
      this.dropDownBlocks = false;
      var obj = clone(block);
      obj.data = JSON.stringify(obj.data);
      this.editor = obj;

      this.block.category_id = obj.category_id;
      this.block.id = obj.id;
      this.block.image = obj.image;

      this.update();
    },
    newBlock(){
      this.dropDownBlocks = false;
      this.editor = {
        name:'',
        data:'{}',
        aside:'<div></div>',
        template:'<div></div>',
        css:'',
        js:'',
      }
      this.block.id = null;
      this.block.category_id = null;
      this.block.image = '';
      this.update();
    },

    update:function(){
      if(!this.iframeDom) return;
      this.block.name = this.editor.name;
      this.block.data = JSON.parse(this.editor.data);
      this.block.aside = this.editor.aside;
      this.block.css = this.editor.css;
      this.block.js = this.editor.js;
      this.block.template = this.editor.template;
      this.createComponent(this.block);
      this.updatePreview(this.block.uid,this.block.data,this.block.css,this.block.js);

    },

   createComponent:function(obj){

      console.log('createComponent',obj);

      var id = uniqid(); //force repaint
      Vue.component('component1-aside'+id, {
        name:'component1-aside'+id,
        template:obj.aside,
        data:() => obj.data,
        mixins: [componentFunctions]
      })

      Vue.component('component1-preview'+id, {
        name:'component1-preview'+id,
        template:obj.template,
        data:() => obj.data,
        watch:{
          '$data':{
            handler:(data,oldVal)=>{
              this.updatePreview(obj.uid,data,obj.css,obj.js);
              this.updateSource(data);
              this.edited = true;
            },
            deep: true,
            immediate: true,
          }
        }
      });

      this.asideComponent = 'component1-aside'+id;
      this.previewComponent = 'component1-preview'+id;

    },
    updateSource(data){
      console.log(data);
      console.log(json_encode(data))
      this.editor.data = json_encode(data);
    },

    updatePreview(uid,data,css,js){
      console.log('updatePreview', uid)
      this.$nextTick(()=>{
        var html = document.querySelector('.virtualPreview').innerHTML;

        //replace variables in css
        var i;
        for (i in data){
          var regEx = new RegExp('var\\(--'+i+'\\)','g');
          css = css.replace(regEx,data[i])
        } 

        //remove null properties
        css = css.replace(/background-image:\s?url\((null)?\);?/g,'')

        css = this.mutateCss('.block-'+uid,css);

        this.updateOutputBlock(uid,html,css,js);
        this.iframeDom.updateBlock(uid,html,css,js);
      });
    },
    mutateCss(prefix,css){
      css = css.replace(/(^|,|}| )([ \t]*)([.#a-z][^{}]*?\s*){/gm,'$1$2'+prefix+' $3 {');
      //css = css.replace(/,(\n)?([ \t]*)([^\n{,]+)({|,)/gm,',$1$2'+prefix+' $3$4');
      return css; 
      //return css.replace(/(^|,|}| )([ \t]*)([.#a-z][^{}]*?\s*)(,|{)/gm,'$1$2'+prefix+' $3$4');
      //return css.replace(/^(\s*)([^@][^\n]*[{,]) *$/gm,'$1'+prefix+' $2');
    },
    updateOutputBlock(uid,html,css,js){
      this.block.output_html = html;
      this.block.output_css = css;
      this.block.output_js = js;
    },
    saveNewBlock(){
      if(!this.block.name){
        alert('Block Name is required');
        return;
      }
      var existing = this.components.find((item)=>{ item.name.toLowerCase() == this.block.name.toLowerCase() })
      if(existing){
        alert('Block Name already exists');
        return;
      }

      var newBlock = {
        name:this.block.name,
        category_id:this.block.category_id,
        image:this.block.image,
        data:this.block.data,
        aside:this.block.aside,
        css:this.block.css,
        js:this.block.js,
        template:this.block.template,
      }

      axios({
        method: 'post',
        url: '/api/newBlock',
        data: newBlock
      }).then((res)=>{
        this.block.id = res.data;
        this.getComponents();
      });

      alert('salvo!');


    },
    deleteBlock(){
      if(!confirm('Certeza?')) return;
      axios({
        method: 'delete',
        url: '/api/block/'+this.block.id,
      }).then(()=>{
        this.getComponents();
        this.newBlock();
      });
    },
    autoThumbnail(){
      var node = document.querySelector('iframe.preview').contentWindow.document.querySelector('body');

      domtoimage.toPng(node)
          .then((dataUrl)=> {
              var img = new Image();
              img.src = dataUrl;
              console.log('ok');
              var data = {
                name:'block-thumbnail.png',
                content:dataUrl
              }
              axios.post('/api/upload',data,{
                onUploadProgress: (progressEvent) => {
                  const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                  if (totalLength !== null) {
                    //console.log('progress',Math.round( (progressEvent.loaded * 100) / totalLength ));
                      //this.progress = Math.round( (progressEvent.loaded * 100) / totalLength );
                    }
                  }
                })
              .then((response)=> {
                console.log('upload complete')
                this.block.image = response.data
              })
              .catch((error) =>  {
                console.error(error);
                if(error.response) alert(error.response.data);
              })

              
          })
          .catch(function (error) {
              console.error('oops, something went wrong!', error);
          });
    },
    saveBlock(){

      if(!this.block.name){
        alert('Block Name is required');
        return;
      }
      var newBlock = {
        id:this.block.id,
        name:this.block.name,
        category_id:this.block.category_id,
        image:this.block.image,
        data:this.block.data,
        aside:this.block.aside,
        css:this.block.css,
        js:this.block.js,
        template:this.block.template,
      }
        console.log(newBlock)

      axios({
        method: 'post',
        url: '/api/newBlock',
        data: newBlock
      }).then(()=>{
        this.getComponents();
      });

      alert('salvo!');

    },
  },
  mounted(){
    this.getComponents();

    document.querySelector('iframe.preview').onload = () => {
      this.iframeDom = document.querySelector('iframe.preview').contentWindow;
      this.update();
    }

  }

}



</script>

